<template>
  <div v-cloak>
    <vs-tabs vs-alignment="fixed" alignment="fixed">
      <vs-tab :label="$t('ActiveDiscounts')" class="mt-2">
        <active-discounts></active-discounts>
      </vs-tab>
      <vs-tab :label="$t('ArchiveDiscounts')" class="mt-2">
        <archive-discounts></archive-discounts>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import ActiveDiscounts from "./ActiveDiscounts.vue";
import ArchiveDiscounts from "./ArchiveDiscounts.vue";

export default {
  name: "saleManagement_Contract_Management_Discounts_Discount",
  components: {
    ActiveDiscounts,
    ArchiveDiscounts
  }
};
</script>
